/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'

/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION SITE THEME SECTION - USER STATUS BADGES: STYLES --------------- ++++++++++ */
export default theme => ({
  userbadge: {
    fontFamily: '"Work Sans", sans-serif;',
    fontSize: '12px',
    fontWeight: 500,
    height: 'auto',
    width: 'auto',
    borderRadius: pxToEm(4),
    padding: '4px 8px',
    display: 'flex',
    alignItems: 'center',
    gap: pxToEm(8),
    '& svg': {
      width: '16px',
      height: '16px',
    },
    '&.darkmonochrome-true': {
      '& *[fill]:not(svg)': {
        fill: ({ themeColors }) => themeColors.secondary || '#FFF',
        stroke: ({ themeColors }) => themeColors.secondary || '#FFF',
        strokeWidth: '0.5px'
      }
    }
  }
});
